/**
 * Mapping of control keys to their display descriptions
 * @type {Object.<string, string>}
 */
export const controlDescriptions = {
  jump: 'Saltar',
  jumpAlt: 'Saltar',
  left: 'Izquierda',
  right: 'Derecha',
  invertColors: 'Invertir colores',
  restart: 'Reiniciar'
}; 